// src/services/apiService.js

import axios from 'axios';
import authService from './authService';

const API_URL = process.env.VUE_APP_API_URL;

const apiService = {
    // Use this method to make authenticated GET requests
    get(endpoint) {
        return axios.get(`${API_URL}/${endpoint}`, {
            headers: {
                Authorization: `Bearer ${authService.getToken()}`
            }
        });
    },

    // Use this method to make authenticated POST requests
    post(endpoint, data) {
        return axios.post(`${API_URL}/${endpoint}`, data, {
            headers: {
                Authorization: `Bearer ${authService.getToken()}`
            }
        });
    }
};

export default apiService;
